import { render, staticRenderFns } from "./Error_404.vue?vue&type=template&id=673de6ed&scoped=true&"
import script from "./Error_404.vue?vue&type=script&lang=js&"
export * from "./Error_404.vue?vue&type=script&lang=js&"
import style0 from "./Error_404.vue?vue&type=style&index=0&id=673de6ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673de6ed",
  null
  
)

export default component.exports